export const OS = {
  iOS: "iOS",
  android: "android",
  other: "other",
} as const;
